export default __webpack_public_path__ + "static/media/rice_grains.2075c867.png";